<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title fw-semibold mb-4">Detail Pemeriksaan</h5>
            <hr class="border-0 pt-1 rounded bg-primary my-4">

            <div class="row g-4">
              <div class="col-lg-3">
                <div class="mb-3">
                  <label for class="small mb-1">Nama Responden :</label>
                  <div class="form-label">{{ safeGet(dataUser, 'user_profile.fullname') }}</div>
                </div>
                <div class="mb-3">
                  <label for class="small mb-1">NIK / Nomor Penduduk :</label>
                  <div class="form-label">{{displayValue(safeGet(dataUser, 'user_profile.nik'))}}</div>
                </div>
                <div class="mb-3">
                  <label for class="small mb-1">Tanggal Lahir :</label>
                  <div class="form-label">{{ safeGet(dataUser, 'user_profile.birth_date') }}</div>
                </div>
                <div class="mb-3">
                  <label for class="small mb-1">Jenis Kelamin :</label>
                  <div class="form-label">{{ safeGet(dataUser, 'user_profile.gender') }}</div>
                </div>
                <div class="mb-3">
                  <label for class="small mb-1">Usia :</label>
                  <div
                    class="form-label"
                  >{{ hitungUsia(safeGet(dataUser, 'user_profile.birth_date')) }} Tahun</div>
                </div>
                <div class="mb-3">
                  <label for class="small mb-1">Alamat Tinggal :</label>
                  <div
                    class="form-label"
                  >{{ displayValue(safeGet(dataUser, 'user_profile.address')) }}</div>
                </div>
                <div class="mb-3">
                  <label for class="small mb-1">Kontak :</label>
                  <div class="form-label">
                    <i class="ti ti-mail"></i>
                    {{dataUser.email}}
                    <br>
                    <i class="ti ti-phone"></i>
                    {{ safeGet(dataUser, 'user_profile.telp') }}
                  </div>
                </div>
              </div>
              <div class="col-lg-9">
                <div class="row row-cols-3 g-4">
                  <div class="col">
                    <label for class="small mb-1">Tanggal Pemeriksaan :</label>
                    <div class="form-label">{{formatDate(date)}}</div>
                  </div>
                  <div class="col">
                    <label for class="small mb-1">Dokter / Petugas Pemeriksa :</label>
                    <div
                      v-if="type== 'umum'"
                      class="form-label"
                    >{{(resultExamList.length > 0) ? resultExamList[0].doctor.user_profile.fullname : '-'}}</div>
                    <div
                      v-else
                      class="form-label"
                    >{{(resultExamList && resultExamList.doctor) ? resultExamList.doctor.user_profile.fullname : '-' }}</div>
                  </div>
                  <div class="col text-end">
                    <label for class="small mb-1">Nomor Antrian :</label>
                    <div class="form-label">-</div>
                  </div>
                </div>

                <hr>

                <form @submit.prevent="onSubmit">
                  <ul class="nav nav-pills mb-4 gap-1" id="pills-tab" role="tablist">
                    <li v-if="type == 'umum'" class="nav-item" role="presentation">
                      <button
                        class="nav-link active"
                        id="pills-0-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-0"
                        type="button"
                        role="tab"
                        aria-controls="pills-0"
                        aria-selected="true"
                      >Kesehatan Umum</button>
                    </li>
                    <li v-if="type == 'kehamilan'" class="nav-item" role="presentation">
                      <button
                        class="nav-link active"
                        id="pills-1-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-1"
                        type="button"
                        role="tab"
                        aria-controls="pills-1"
                        aria-selected="true"
                      >Kontrol Kehamilan</button>
                    </li>
                    <li v-if="type == 'persalinan'" class="nav-item" role="presentation">
                      <button
                        class="nav-link active"
                        id="pills-2-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-2"
                        type="button"
                        role="tab"
                        aria-controls="pills-2"
                        aria-selected="true"
                      >Persalinan</button>
                    </li>
                    <li v-if="type == 'postpartum'" class="nav-item" role="presentation">
                      <button
                        class="nav-link active"
                        id="pills-3-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-3"
                        type="button"
                        role="tab"
                        aria-controls="pills-3"
                        aria-selected="true"
                      >Postpartum</button>
                    </li>
                  </ul>

                  <div class="tab-content" id="pills-tabContent">
                    <div
                      v-if="type == 'umum'"
                      class="tab-pane fade show active"
                      id="pills-0"
                      role="tabpanel"
                      aria-labelledby="pills-0-tab"
                      tabindex="0"
                    >
                      <!-- Control Section Start -->
                      <label for class="form-label text-uppercase mb-4">Kesehatan Umum</label>
                      <div class="table-responsive">
                        <table class="table table-striped align-middle">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th class="w-25" scope="col">Pemeriksaan</th>
                              <th scope="col">Hasil</th>
                              <!-- <th class="text-center" scope="col">Status</th> -->
                              <th scope="col">Referensi</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(req, idx) in resultExamList" :key="req.id">
                              <th scope="row">{{ idx + 1 }}</th>
                              <td class="fw-bold">{{ req.examination_name }}</td>
                              <td class="fw-bold text-nowrap">
                                <div class="mb-2">
                                  <input
                                    v-model="req.result"
                                    type="text"
                                    class="form-control form-control-sm bg-light fw-bold mx-auto"
                                    placeholder="Hasil..."
                                    autocomplete="off"
                                  >
                                  <!-- required -->
                                </div>
                              </td>
                              <td>
                                <ul class="nav small flex-column">
                                  <li>
                                    <b>Unit :</b>
                                    {{req.unit}}
                                  </li>
                                  <li>
                                    <b>Rujukan :</b>
                                    {{req.reverence_value}}
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="mb-3">
                        <label for class="form-label">Keluhan</label>
                        <div
                          class="alert alert-secondary fst-italic fw-medium"
                        >{{resultExamList != '' ? resultExamList[0].remark : '-'}}</div>
                      </div>
                      <div class="d-md-flex gap-3">
                        <textarea
                          v-model="diagnoses"
                          class="form-control mb-3 mb-md-0"
                          placeholder="Diagnosa..."
                          rows="3"
                        ></textarea>
                        <textarea
                          v-model="treatment"
                          class="form-control"
                          placeholder="Tindakan..."
                          rows="3"
                        ></textarea>
                      </div>
                      <!-- Control Section End -->
                    </div>

                    <div
                      v-if="type == 'kehamilan'"
                      class="tab-pane fade show active"
                      id="pills-1"
                      role="tabpanel"
                      aria-labelledby="pills-1-tab"
                      tabindex="0"
                    >
                      <!-- Control Section Start -->
                      <label for class="form-label text-uppercase mb-4">Kontrol Kehamilan</label>
                      <!-- <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">Profil Kehamilan *</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <select
                            v-model="form2.pregnancyId"
                            @change="setHPL()"
                            class="form-select"
                            autocomplete="off"
                          >
                            <option value disabled hidden>--- Pilih ---</option>
                            <option
                              v-for="item in pregnancyList"
                              :value="item.id"
                              :key="`pl${item.id}`"
                            >{{item.profile_kehamilan}}</option>
                          </select>
                        </div>
                      </div>-->
                      <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">Profil Kehamilan</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <input
                            v-model="form2.user_pregnancies.profile"
                            type="text"
                            class="form-control"
                            placeholder="Profil Kehamilan..."
                            autocomplete="off"
                            disabled
                          >
                        </div>
                      </div>

                      <div class="mb-3">
                        <hr>
                        <div class="fs-4 mb-3 text-info fw-medium">Umum</div>

                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Tinggi Badan Ibu</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              type="text"
                              v-model="form2.height"
                              class="form-control"
                              placeholder="Tinggi Badan Ibu..."
                              autocomplete="off"
                            >
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Berat Badan Ibu</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              type="text"
                              v-model="form2.weight"
                              class="form-control"
                              placeholder="Berat Badan Ibu..."
                              autocomplete="off"
                            >
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Emosional Stabil</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form2.stable_affect"
                                class="form-check-input"
                                type="radio"
                                name="inlineRadioOptions"
                                value="Ya"
                                id="Ya"
                                autocomplete="off"
                                checked
                              >
                              <label class="form-check-label" for="Ya">Ya</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form2.stable_affect"
                                class="form-check-input"
                                type="radio"
                                name="inlineRadioOptions"
                                value="Tidak"
                                id="Tidak"
                                autocomplete="off"
                              >
                              <label class="form-check-label" for="Tidak">Tidak</label>
                            </div>
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Keadaan Umum</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form2.general_condition"
                                class="form-check-input"
                                type="radio"
                                name="inlineRadioOptions2"
                                value="Composmentis"
                                id="Composmentis"
                                autocomplete="off"
                                checked
                              >
                              <label class="form-check-label" for="Composmentis">Composmentis</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form2.general_condition"
                                class="form-check-input"
                                type="radio"
                                name="inlineRadioOptions2"
                                value="Somnolent"
                                id="Somnolent"
                                autocomplete="off"
                              >
                              <label class="form-check-label" for="Somnolent">Somnolent</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form2.general_condition"
                                class="form-check-input"
                                type="radio"
                                name="inlineRadioOptions2"
                                value="Apatis"
                                id="Apatis"
                                autocomplete="off"
                              >
                              <label class="form-check-label" for="Apatis">Apatis</label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mb-3">
                        <hr>
                        <div class="fs-4 mb-3 text-info fw-medium">Tanda-Tanda Vital</div>

                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Tekanan Darah Ibu</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              type="text"
                              v-model="form2.blood_preasure"
                              class="form-control"
                              placeholder="Tekanan Darah Ibu..."
                              autocomplete="off"
                            >
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Nadi</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              type="text"
                              v-model="form2.pulse_rate"
                              class="form-control"
                              placeholder="Nadi..."
                              autocomplete="off"
                            >
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Suhu Badan</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              type="text"
                              v-model="form2.body_temperature"
                              class="form-control"
                              placeholder="Suhu Badan..."
                              autocomplete="off"
                            >
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Pernafasan</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              type="text"
                              v-model="form2.respiratory_rate"
                              class="form-control"
                              placeholder="Pernafasan..."
                              autocomplete="off"
                            >
                          </div>
                        </div>
                      </div>

                      <div class="mb-3">
                        <hr>
                        <div class="fs-4 mb-3 text-info fw-medium">Extermitas</div>

                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Oedema</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form2.oedema"
                                class="form-check-input"
                                type="radio"
                                name="inlineRadioOptions3"
                                value="Ya"
                                id="oya"
                                autocomplete="off"
                                checked
                              >
                              <label class="form-check-label" for="oya">Ya</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form2.oedema"
                                class="form-check-input"
                                type="radio"
                                name="inlineRadioOptions3"
                                value="Tidak"
                                id="oTidak"
                                autocomplete="off"
                              >
                              <label class="form-check-label" for="oTidak">Tidak</label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mb-3">
                        <hr>
                        <div class="fs-4 mb-3 text-info fw-medium">Laboratorium</div>

                        <div class="mb-3">
                          <label for class="col-form-label">Pemeriksaan Darah Rutin</label>
                          <div class="d-flex gap-2">
                            <div class="input-group">
                              <span class="input-group-text" id="basic-addon1">Hemoglobin</span>
                              <input
                                type="text"
                                v-model="form2.hemoglobin"
                                class="form-control"
                                placeholder="Hemoglobin..."
                                autocomplete="off"
                              >
                            </div>
                            <div class="input-group">
                              <span class="input-group-text" id="basic-addon1">Trombosit</span>
                              <input
                                type="text"
                                v-model="form2.trombosit"
                                class="form-control"
                                placeholder="Trombosit..."
                                autocomplete="off"
                              >
                            </div>
                            <div class="input-group">
                              <span class="input-group-text" id="basic-addon1">Leukosit</span>
                              <input
                                type="text"
                                v-model="form2.leukosit"
                                class="form-control"
                                placeholder="Leukosit..."
                                autocomplete="off"
                              >
                            </div>
                          </div>
                        </div>
                        <div class="mb-3">
                          <label for class="col-form-label">Pemeriksaan Triple Eleminasi</label>
                          <div class="d-flex gap-2">
                            <div class="input-group">
                              <span class="input-group-text" id="basic-addon1">HIV</span>
                              <input
                                type="text"
                                v-model="form2.hiv"
                                class="form-control"
                                placeholder="HIV..."
                                autocomplete="off"
                              >
                            </div>
                            <div class="input-group">
                              <span class="input-group-text" id="basic-addon1">Sifilis</span>
                              <input
                                type="text"
                                v-model="form2.sifilis"
                                class="form-control"
                                placeholder="Sifilis..."
                                autocomplete="off"
                              >
                            </div>
                            <div class="input-group">
                              <span class="input-group-text" id="basic-addon1">HBSAG</span>
                              <input
                                type="text"
                                v-model="form2.hbsag"
                                class="form-control"
                                placeholder="HBSAG..."
                                autocomplete="off"
                              >
                            </div>
                          </div>
                        </div>
                        <div class="mb-3">
                          <label for class="col-form-label">Pemeriksaan Gula Darah</label>
                          <div class="d-flex gap-2">
                            <div class="input-group">
                              <span class="input-group-text" id="basic-addon1">Sewaktu</span>
                              <input
                                type="text"
                                v-model="form2.random_blood_glucose"
                                class="form-control"
                                placeholder="Sewaktu..."
                                autocomplete="off"
                              >
                            </div>
                            <div class="input-group">
                              <span class="input-group-text" id="basic-addon1">Puasa</span>
                              <input
                                type="text"
                                v-model="form2.fasting_blood_glucose"
                                class="form-control"
                                placeholder="Puasa..."
                                autocomplete="off"
                              >
                            </div>
                          </div>
                        </div>
                        <div class="mb-3">
                          <label for class="col-form-label">Pemeriksaan Urin</label>
                          <div class="d-flex gap-2">
                            <div class="input-group">
                              <span class="input-group-text" id="basic-addon1">Protein</span>
                              <input
                                type="text"
                                v-model="form2.urine_protein"
                                class="form-control"
                                placeholder="Protein..."
                                autocomplete="off"
                              >
                            </div>
                            <div class="input-group">
                              <span class="input-group-text" id="basic-addon1">Warna</span>
                              <input
                                type="text"
                                v-model="form2.urine_color"
                                class="form-control"
                                placeholder="Warna..."
                                autocomplete="off"
                              >
                            </div>
                          </div>
                        </div>
                      </div>

                      <hr class="pt-1 border-0 rounded bg-dark my-4">

                      <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">HPHT</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <input
                            v-model="hpht"
                            type="date"
                            class="form-control"
                            placeholder="HPHT..."
                            autocomplete="off"
                            disabled
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">HPL</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <input
                            v-model="hpl"
                            type="date"
                            class="form-control"
                            placeholder="HPL..."
                            autocomplete="off"
                            disabled
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">Usia Kehamilan</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <input
                            v-model="form2.pregnancy_age"
                            type="text"
                            class="form-control"
                            value
                            placeholder="Usia Kehamilan..."
                            autocomplete="off"
                            disabled
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">Presentasi Janin</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <select
                            v-model="form2.fetal_presentation"
                            class="form-select"
                            autocomplete="off"
                          >
                            <option value disabled hidden>--- Pilih ---</option>
                            <option
                              value="Kepala Di Bawah (Cephalic / Vertex Presentation)"
                            >Kepala Di Bawah (Cephalic / Vertex Presentation)</option>
                            <option
                              value="Lintang (Transverse Lie) - Janin melintang, bahu menghadap jalan lahir"
                            >Lintang (Transverse Lie) - Janin melintang, bahu menghadap jalan lahir</option>
                            <option
                              value="Oblique Lie - Janin miring / diagonal"
                            >Oblique Lie - Janin miring / diagonal</option>
                            <option
                              value="Sungsang (Breech Presentation) - Bokong atau kaki di bawah"
                            >Sungsang (Breech Presentation) - Bokong atau kaki di bawah</option>
                            <option
                              value="Sungsang (Breech Frank) - Pantat di bawah, kaki lurus ke atas"
                            >Sungsang (Breech Frank) - Pantat di bawah, kaki lurus ke atas</option>
                            <option
                              value="Sungsang (Breech Complete) - Pantat di bawah, kaki terlipat"
                            >Sungsang (Breech Complete) - Pantat di bawah, kaki terlipat</option>
                            <option
                              value="Sungsang (Breech Footling) - Kaki di bawah"
                            >Sungsang (Breech Footling) - Kaki di bawah</option>
                            <option
                              value="Tidak Dapat Dinilai - Posisi tidak jelas"
                            >Tidak Dapat Dinilai - Posisi tidak jelas</option>
                          </select>
                        </div>
                      </div>
                      <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">Denyut Jantung Janin</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <input
                            type="text"
                            v-model="form2.fetal_heart_rate"
                            class="form-control"
                            placeholder="Denyut Jantung Janin..."
                            autocomplete="off"
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">Posisi Plasenta</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <select
                            v-model="form2.placenta_position"
                            class="form-select"
                            autocomplete="off"
                          >
                            <option value disabled hidden>--- Pilih ---</option>
                            <option
                              value="Anterior (Di dinding depan rahim)"
                            >Anterior (Di dinding depan rahim)</option>
                            <option
                              value="Posterior (Di dinding belakang rahim)"
                            >Posterior (Di dinding belakang rahim)</option>
                            <option value="Lateral Kanan">Lateral Kanan</option>
                            <option value="Lateral Kiri">Lateral Kiri</option>
                            <option value="Fundus (Di puncak rahim)">Fundus (Di puncak rahim)</option>
                            <option
                              value="Low-lying / Plasenta Letak Rendah"
                            >Low-lying / Plasenta Letak Rendah</option>
                            <option
                              value="Previa Totalis (Menutupi seluruh jalan lahir)"
                            >Previa Totalis (Menutupi seluruh jalan lahir)</option>
                            <option
                              value="Previa Partialis (Menutupi sebagian jalan lahir)"
                            >Previa Partialis (Menutupi sebagian jalan lahir)</option>
                            <option
                              value="Previa Marginalis (Hanya tepi plasenta yang mengenai jalan lahir)"
                            >Previa Marginalis (Hanya tepi plasenta yang mengenai jalan lahir)</option>
                          </select>
                        </div>
                      </div>
                      <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">Cairan Ketuban</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <select
                            v-model="form2.amniotic_fluid"
                            class="form-select"
                            autocomplete="off"
                          >
                            <option value disabled hidden>--- Pilih ---</option>
                            <option value="Normal">Normal</option>
                            <option value="Sedikit (Oligohidramnion)">Sedikit (Oligohidramnion)</option>
                            <option value="Banyak (Polihidramnion)">Banyak (Polihidramnion)</option>
                            <option value="Lainnya">Lainnya</option>
                          </select>
                        </div>
                      </div>
                      <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">BB Janin (Estimasi)</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <input
                            type="text"
                            v-model="form2.estimated_fetal_weight"
                            class="form-control"
                            placeholder="BB Janin..."
                            autocomplete="off"
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">Tafsiran Fetus Uteri (TFU)</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <input
                            v-model="form2.tfu"
                            type="text"
                            class="form-control"
                            placeholder="Tafsiran Fetus Uteri..."
                            autocomplete="off"
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">Jenis Kelamin</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <div class="form-check form-check-inline">
                            <input
                              v-model="form2.fetal_gender"
                              class="form-check-input"
                              type="radio"
                              name="inlineRadioOptions4"
                              id="inlineRadio1"
                              value="Laki-laki"
                              autocomplete="off"
                            >
                            <label class="form-check-label" for="inlineRadio1">Laki-laki</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input
                              v-model="form2.fetal_gender"
                              class="form-check-input"
                              type="radio"
                              name="inlineRadioOptions4"
                              id="inlineRadio2"
                              value="Perempuan"
                              autocomplete="off"
                            >
                            <label class="form-check-label" for="inlineRadio2">Perempuan</label>
                          </div>
                        </div>
                      </div>

                      <hr>

                      <div class="mb-3">
                        <label for class="form-label">Keluhan</label>
                        <div
                          class="alert alert-secondary fst-italic fw-medium"
                        >{{form2.remark || '-'}}</div>
                      </div>
                      <div class="d-md-flex gap-3">
                        <textarea
                          v-model="diagnoses"
                          class="form-control mb-3 mb-md-0"
                          placeholder="Diagnosa..."
                          rows="3"
                          autocomplete="off"
                        ></textarea>
                        <textarea
                          v-model="treatment"
                          class="form-control"
                          placeholder="Tindakan..."
                          rows="3"
                          autocomplete="off"
                        ></textarea>
                      </div>
                      <!-- Control Section End -->
                    </div>

                    <div
                      v-if="type == 'persalinan'"
                      class="tab-pane fade show active"
                      id="pills-2"
                      role="tabpanel"
                      aria-labelledby="pills-1-tab"
                      tabindex="0"
                    >
                      <label for class="form-label text-uppercase mb-4">Persalinan</label>
                      <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">Profil Kehamilan *</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <input
                            v-model="pregnancy"
                            type="text"
                            class="form-control"
                            placeholder="Profil Kehamilan..."
                            autocomplete="off"
                            disabled
                          >
                        </div>
                      </div>

                      <hr>

                      <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">Waktu Kedatangan *</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <input
                            type="datetime-local"
                            v-model="form4.created_date"
                            class="form-control bg-white"
                            autocomplete="off"
                          >
                        </div>
                      </div>
                      <div class="mb-3">
                        <textarea
                          v-model="form4.remark"
                          class="form-control"
                          placeholder="Catatan Medis..."
                          rows="3"
                        ></textarea>
                      </div>

                      <div class="row g-0 g-sm-3 align-items-center mb-3">
                        <div class="col-sm-4 col-md-3">
                          <label for class="col-form-label">Sudah Persalinan?</label>
                        </div>
                        <div class="col-sm-8 col-md-9">
                          <div class="form-check form-check-inline">
                            <input
                              v-model="form4.delivery_status"
                              class="form-check-input"
                              type="radio"
                              value="1"
                              name="finished_delivery"
                              id="inlineRadio555"
                              autocomplete="off"
                            >
                            <label class="form-check-label" for="inlineRadio555">Sudah</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input
                              v-model="form4.delivery_status"
                              class="form-check-input"
                              type="radio"
                              value="0"
                              name="finished_delivery"
                              id="inlineRadio666"
                              autocomplete="off"
                            >
                            <label class="form-check-label" for="inlineRadio666">Belum</label>
                          </div>

                          <div v-if="form4.delivery_status == 1" class="p-4 rounded bg-light mt-3">
                            <div class="row g-0 g-lg-3 align-items-center mb-3">
                              <div class="col-md-5 col-xl-4 col-xxl-3">
                                <label for class="col-form-label">Waktu Persalinan *</label>
                              </div>
                              <div class="col-md-7 col-xl-8 col-xxl-9">
                                <input
                                  type="datetime-local"
                                  v-model="form4.delivery_date"
                                  class="form-control bg-white"
                                  autocomplete="off"
                                >
                              </div>
                            </div>
                            <div>
                              <textarea
                                v-model="form4.delivery_remark"
                                class="form-control bg-white"
                                placeholder="Catatan Medis..."
                                rows="3"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="type == 'postpartum'"
                      class="tab-pane fade show active"
                      id="pills-3"
                      role="tabpanel"
                      aria-labelledby="pills-1-tab"
                      tabindex="0"
                    >
                      <label for class="form-label text-uppercase mb-4">Postpartum</label>
                      <div class="rounded">
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Profil Kehamilan *</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              v-model="pregnancy"
                              type="text"
                              class="form-control"
                              placeholder="Profil Kehamilan..."
                              autocomplete="off"
                              disabled
                            >
                          </div>
                        </div>
                        <hr>

                        <div class="row g-0 g-lg-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Waktu Kelahiran *</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              type="datetime-local"
                              v-model="form3.delivery_date"
                              class="form-control bg-white"
                              autocomplete="off"
                              required
                            >
                          </div>
                        </div>
                        <div class="row g-0 g-lg-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Jenis Persalinan *</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form3.delivery_type"
                                value="Normal"
                                class="form-check-input"
                                type="radio"
                                name="delivery_type"
                                id="inlineRadio111"
                                autocomplete="off"
                                required
                              >
                              <label class="form-check-label" for="inlineRadio111">Normal</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form3.delivery_type"
                                value="Cesarean"
                                class="form-check-input"
                                type="radio"
                                name="delivery_type"
                                id="inlineRadio222"
                                autocomplete="off"
                              >
                              <label class="form-check-label" for="inlineRadio222">Cesarean</label>
                            </div>
                          </div>
                        </div>
                        <div class="row g-0 g-lg-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Kondisi Ibu *</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              v-model="form3.maternal_condition"
                              type="text"
                              class="form-control bg-white"
                              placeholder="Kondisi Ibu..."
                              autocomplete="off"
                              required
                            >
                          </div>
                        </div>
                        <div class="row g-0 g-lg-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Kondisi Bayi *</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              v-model="form3.fetal_condition"
                              type="text"
                              class="form-control bg-white"
                              placeholder="Kondisi Bayi..."
                              autocomplete="off"
                              required
                            >
                          </div>
                        </div>
                        <div class="row g-0 g-lg-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Menyusui *</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form3.breeding"
                                value="1"
                                class="form-check-input"
                                type="radio"
                                name="breeding"
                                id="inlineRadio1111"
                                autocomplete="off"
                                required
                              >
                              <label class="form-check-label" for="inlineRadio1111">Ya</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form3.breeding"
                                value="0"
                                class="form-check-input"
                                type="radio"
                                name="breeding"
                                id="inlineRadio2221"
                                autocomplete="off"
                              >
                              <label class="form-check-label" for="inlineRadio2221">Tidak</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button type="submit" class="btn btn-primary mt-4">Simpan</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import { allMixin } from '@/mixins/allMixin.js'

export default {
	mixins: [allMixin],
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			token: localStorage.getItem('token'),
			diagnoses: '',
			treatment: '',
			type_examination: [],
			form: {
				userId: '',
				examination_date: new Date().toISOString(),
				examination_purpose: [],
				records: [
					{
						examination_name: '',
						unit: '',
						reference_value: '',
						description: '',
						result: '',
						remark: '',
						diagnoses: '',
						treatment: '',
						examination_purpose: ''
					}
				]
			},
			hpht: '',
			hpl: '',
			form2: {
				pregnancyId: '',
				control_date: new Date().toISOString(),
				pregnancy_age: '',
				blood_preasure: '',
				remark: '',
				statusId: '7',
				fetal_presentation: '',
				fetal_heart_rate: '',
				placenta_position: '',
				amniotic_fluid: '',
				estimated_fetal_weight: '',
				fetal_gender: '',
				examination_purpose: '',
				diagnoses: '',
				treatment: '',
				tfu: '',
				user_pregnancies: { profile: '' }
			},
			form3: {
				//Postpartum
				delivery_date: '',
				delivery_type: '', //Normal
				maternal_condition: '',
				fetal_condition: '',
				breeding: 1
			},
			form4: {
				//Persalinan
				pregnancyId: '',
				created_date: '',
				remark: '',
				delivery_status: 1,
				delivery_date: '',
				delivery_remark: ''
			},
			pregnancy: '',
			file: null,
			preview: '',
			title: 'Tambah',
			button: 'Simpan',
			url2: 'user_spesialized/',
			method: 'post'
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
		if (this.type == 'kehamilan') {
			this.$store
				.dispatch('location/getDataPayload3', {
					url: `user_pregnancies_data/${this.id}`
				})
				.then((res) => {
					console.log('-------------------', res)
					this.form2 = res.payload
					this.hpl = res.payload.user_pregnancies.hpl
					this.hpht = res.payload.user_pregnancies.hpht
					this.diagnoses = res.payload.diagnoses
					this.treatment = res.payload.treatment
				})
		} else if (this.type == 'persalinan') {
			this.form4.delivery_status = parseInt(this.form4.delivery_status)
			this.form4.delivery_date = this.form4.delivery_date ? this.localToUtcSameTime(this.form4.delivery_date) : ''
			this.form4.created_date = this.form4.created_date ? this.localToUtcSameTime(this.form4.created_date) : ''
			this.$store
				.dispatch('location/getDataPayload3', {
					url: `user_delivery_journals/${this.id}`
				})
				.then((res) => {
					this.pregnancy = res.payload.user_pregnancies.profile

					this.form4 = {
						//Persalinan
						created_date: this.formatDateHour(res.payload.created_date),
						remark: res.payload.remark,
						delivery_status: res.payload.delivery_status ? 1 : 0,
						delivery_date: this.formatDateHour(res.payload.delivery_date),
						delivery_remark: res.payload.delivery_remark
					}
				})
		} else if (this.type == 'postpartum') {
			this.form3.delivery_date = this.form3.delivery_date ? this.localToUtcSameTime(this.form3.delivery_date) : ''
			this.$store
				.dispatch('location/getDataPayload3', {
					url: `user_pregnancies/profile/${this.id}`
				})
				.then((res) => {
					this.pregnancy = res.payload.profile

					this.form3 = {
						//Postpartum
						delivery_date: this.formatDateHour(res.payload.delivery_date),
						delivery_type: res.payload.delivery_type, //Normal
						maternal_condition: res.payload.maternal_condition,
						fetal_condition: res.payload.fetal_condition,
						breeding: res.payload.breeding,
						statusId: 7
					}
				})
		} else if (this.type == 'umum') {
			this.$store
				.dispatch('location/getDataPayload3', {
					url: `user_examination/${this.userId}`,
					params: {
						examination_date: this.date
					}
				})
				.then((res) => {
					console.log('-------------------', res)
					this.diagnoses = res.payload[0].diagnoses
					this.treatment = res.payload[0].treatment
				})

			this.$store.dispatch('location/getData', {
				url: `medical_examination`,
				params: {
					offset: 0,
					limit: 10000,
					order: 'desc'
				}
			})
		}
		this.$store.dispatch('location/getDataPayload2', {
			url: `users/${this.userId}`
		})
	},
	mounted() {
		this.form.userId = this.userId || ''
	},
	computed: {
		...mapGetters({
			resultExamList: 'location/getDataPayload3',
			dataUser: 'location/getDataPayloadObject',
			pregnancyList: 'location/getDataPayload',
			examList: 'location/getDCLocation'
		}),
		id: {
			// getter
			get() {
				return this.$route.query.id || ''
			}
		},
		userId: {
			// getter
			get() {
				return this.$route.query.userId || ''
			}
		},
		date: {
			// getter
			get() {
				return this.$route.query.date || ''
			}
		},
		type: {
			// getter
			get() {
				return this.$route.query.type
			}
		}
	},
	methods: {
		getCity() {
			this.$store.dispatch('location/getDataPayload2', {
				url: `datasheet/cities/${this.form.province}`
			})
		},
		onSubmit() {
			// let cleanData = this.form2.map(({ createdAt, doctor, doctorId, id, pregnancy_age, site_status, statusId, updatedAt, user_pregnancies, ...rest }) => rest);
			let cleanData = {
				pregnancyId: this.form2.pregnancyId,
				control_date: this.form2.control_date,
				pregnancy_age: this.form2.pregnancy_age,
				blood_preasure: this.form2.blood_preasure,
				remark: this.form2.remark,
				statusId: '7',
				fetal_presentation: this.form2.fetal_presentation,
				fetal_heart_rate: this.form2.fetal_heart_rate,
				placenta_position: this.form2.placenta_position,
				amniotic_fluid: this.form2.amniotic_fluid,
				estimated_fetal_weight: this.form2.estimated_fetal_weight,
				fetal_gender: this.form2.fetal_gender,
				examination_purpose: this.form2.examination_purpose,
				diagnoses: this.form2.diagnoses,
				treatment: this.form2.treatment,
				tfu: this.form2.tfu,
				diagnoses: this.diagnoses,
				treatment: this.treatment
			}
			console.log(cleanData)
			// return
			if (this.type == 'kehamilan') {
				this.$store
					.dispatch('location/createNewRecord', {
						data: cleanData,
						url: 'user_pregnancies_data/update/' + this.form2.id,
						method: 'PUT'
					})
					.then((res) => {
						console.log('log dispatch dari file .vue ==>', res)
						let toast = this.$toasted.show(`${res.msg}`, {
							theme: 'bubble',
							position: 'top-right',
							duration: 3000
						})
						if (res.statusCode == 200) {
							this.$router.push('/user-examination')
						} else {
						}
					})
					.catch((error) => {
						if (error.response) {
							console.log('log catch dispatch dari file .vue ==>', error.response.data.payload)
							let toast = this.$toasted.show(`${error.response.data.payload}`, {
								theme: 'bubble',
								position: 'top-right',
								duration: 3000
							})
						}
					})
			} else if (this.type == 'umum') {
				let rec = this.resultExamList.map((elem) => ({ id: elem['id'], examination_name: elem['examination_name'], unit: elem['unit'], reference_value: elem['reference_value'], description: elem['description'], result: elem['result'], remark: elem['remark'], diagnoses: this.diagnoses, treatment: this.treatment }))
				this.$store
					.dispatch('location/createNewRecord', {
						data: { records: rec },
						url: 'user_examination/update',
						method: 'PUT'
					})
					.then((res) => {
						console.log(res)
						let toast = this.$toasted.show(`${res.msg}`, {
							theme: 'bubble',
							position: 'top-right',
							duration: 3000
						})
						if (res.statusCode == 200) {
							this.$router.push('/user-examination')
						} else {
						}
					})
			} else if (this.type == 'persalinan') {
				this.form4.delivery_date = this.form4.delivery_date != '-' ? this.localToUtcSameTime(this.form4.delivery_date) : ""
				this.form4.created_date = this.localToUtcSameTime(this.form4.created_date)
				this.$store
					.dispatch('location/createNewRecord', {
						data: this.form4,
						url: 'user_delivery_journals/update/' + this.id,
						method: 'PUT'
					})
					.then((res) => {
						let toast = this.$toasted.show(`${res.msg}`, {
							theme: 'bubble',
							position: 'top-right',
							duration: 3000
						})
						if (res.statusCode == 200) {
							this.$router.push('/user-examination')
						} else {
						}
					})
					.catch((error) => {
						if (error.response) {
							console.log('log catch dispatch dari file .vue ==>', error.response.data.payload)
							let toast = this.$toasted.show(`${error.response.data.payload}`, {
								theme: 'bubble',
								position: 'top-right',
								duration: 3000
							})
						}
					})
			} else if (this.type == 'postpartum') {
				this.form3.delivery_date = this.localToUtcSameTime(this.form3.delivery_date)
				this.$store
					.dispatch('location/createNewRecord', {
						data: this.form3,
						url: 'user_pregnancies/update/' + this.id,
						method: 'PUT'
					})
					.then((res) => {
						let toast = this.$toasted.show(`${res.msg}`, {
							theme: 'bubble',
							position: 'top-right',
							duration: 3000
						})
						if (res.statusCode == 200) {
							this.$router.push('/user-examination')
						} else {
						}
					})
					.catch((error) => {
						if (error.response) {
							console.log('log catch dispatch dari file .vue ==>', error.response.data.payload)
							let toast = this.$toasted.show(`${error.response.data.payload}`, {
								theme: 'bubble',
								position: 'top-right',
								duration: 3000
							})
						}
					})
			}
		},
		setHPL() {
			let data = this.pregnancyList.find((o) => o.id === this.form2.pregnancyId)
			this.hpht = data.hpht
			this.hpl = data.hpl
			this.form2.pregnancy_age = String(data.usia_kehamilan_week)
		},
		setPregancy() {
			this.$store.dispatch('location/getDataPayload', {
				url: `user_pregnancies`,
				params: {
					// userId: this.form.userId,
					offset: 0,
					limit: 10000,
					order: 'desc'
				}
			})
		},
		formatDateHour(dateStr) {
			if (!dateStr) return '-' // biar aman kalau null/undefined/kosong
			const d = new Date(dateStr)
			const y = d.getUTCFullYear()
			const m = String(d.getUTCMonth() + 1).padStart(2, '0')
			const day = String(d.getUTCDate()).padStart(2, '0')
			const h = String(d.getUTCHours()).padStart(2, '0')
			const min = String(d.getUTCMinutes()).padStart(2, '0')
			return `${y}-${m}-${day}T${h}:${min}`
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
